var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        staticClass: "media-library-error-svg",
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 1022.7 785.81"
        }
      },
      [
        _c(
          "defs",
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  x1: "678.2",
                  y1: "821.79",
                  x2: "678.2",
                  y2: "493.4",
                  gradientTransform: "translate(-20.24 29.65) rotate(-2.31)",
                  gradientUnits: "userSpaceOnUse"
                }
              },
              [
                _c("stop", {
                  attrs: {
                    offset: "0",
                    "stop-color": "gray",
                    "stop-opacity": "0.25"
                  }
                }),
                _vm._v(" "),
                _c("stop", {
                  attrs: {
                    offset: "0.54",
                    "stop-color": "gray",
                    "stop-opacity": "0.12"
                  }
                }),
                _vm._v(" "),
                _c("stop", {
                  attrs: {
                    offset: "1",
                    "stop-color": "gray",
                    "stop-opacity": "0.1"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("ellipse", {
          attrs: {
            cx: "468.63",
            cy: "660.88",
            rx: "425",
            ry: "33",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("g", { attrs: { opacity: "0.1" } }, [
          _c("path", {
            attrs: {
              d:
                "M933.7,529.93c-2.54-7.71-12.84-11.26-23-7.92a24.76,24.76,0,0,0-4.23,1.83c-.65-.18-1.32-.34-2-.46a22.42,22.42,0,0,0,.63-6.79A24.6,24.6,0,0,0,916,495.12a24.63,24.63,0,0,0,10.86-21.47,23.76,23.76,0,0,0,8.23-9.32c4.9-9.7,2.87-20.6-4.54-24.35s-17.4,1.08-22.3,10.78a23.69,23.69,0,0,0-2.63,12.15,24.63,24.63,0,0,0-10.86,21.47,24.63,24.63,0,0,0-10.86,21.47A24.64,24.64,0,0,0,873,527.33a23.76,23.76,0,0,0-8.23,9.32,25.46,25.46,0,0,0-2.08,5.74,21.18,21.18,0,0,0-4.44-4.73,25.38,25.38,0,0,0-1-4.5c-3.34-10.17-12.3-16.37-20-13.83s-11.26,12.83-7.92,23a23.07,23.07,0,0,0,7.56,11.08,25.38,25.38,0,0,0,1,4.5c1.94,5.9,5.77,10.46,10.15,12.75a23.23,23.23,0,0,0-.83,3.9,25.29,25.29,0,0,0-7.54,14.91,25.27,25.27,0,0,0-7.54,14.92,24.63,24.63,0,0,0-5,6.81c-4.91,9.7-2.88,20.61,4.53,24.35s17.4-1.07,22.31-10.78a24.62,24.62,0,0,0,2.5-8.09,25.29,25.29,0,0,0,7.54-14.91,25.27,25.27,0,0,0,7.54-14.92A25.21,25.21,0,0,0,879,571.94,25.21,25.21,0,0,0,886.56,557a24.11,24.11,0,0,0,3.39-4,23.46,23.46,0,0,0,12.27-.77,24.76,24.76,0,0,0,4.23-1.83,23.2,23.2,0,0,0,13.42-.48C930,546.61,936.23,537.65,933.7,529.93Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#3f3d56"
            }
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.1" } }, [
            _c("path", {
              attrs: {
                d:
                  "M915.77,499.53a21.5,21.5,0,0,1-3.44,2.75,23,23,0,0,1-1.11,8.43,26.18,26.18,0,0,0,2.1-3.43A24.64,24.64,0,0,0,915.77,499.53Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M926.63,478.06a21.5,21.5,0,0,1-3.44,2.75,23,23,0,0,1-1.11,8.43,25.65,25.65,0,0,0,2.1-3.44A24.85,24.85,0,0,0,926.63,478.06Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M902,470.07a21.91,21.91,0,0,1,.17-4.41,24.93,24.93,0,0,0-4.78,6.57,25.63,25.63,0,0,0-1.52,3.73A22.75,22.75,0,0,1,902,470.07Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M833.07,600a23.59,23.59,0,0,1,2.95-3.38,22.92,22.92,0,0,1,.87-4,25.09,25.09,0,0,0-2.29,3.71A25.59,25.59,0,0,0,833.07,600Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M840.61,585.1a23.59,23.59,0,0,1,2.95-3.38,23,23,0,0,1,.83-3.9l0,0a25.68,25.68,0,0,0-2.2,3.59A26.76,26.76,0,0,0,840.61,585.1Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M904.9,521a20.82,20.82,0,0,1-3.43,2.74,22.45,22.45,0,0,1-.63,6.79,18.75,18.75,0,0,1,2,.46,24.76,24.76,0,0,1,4.23-1.83c10.18-3.34,20.47.21,23,7.92a11.68,11.68,0,0,1,.32,6c3.35-3.94,4.74-8.74,3.3-13.14-2.54-7.71-12.84-11.26-23-7.92a24.76,24.76,0,0,0-4.23,1.83c-.65-.18-1.32-.34-2-.46C904.65,522.59,904.79,521.8,904.9,521Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M829.35,607.49a25.09,25.09,0,0,0-2.29,3.71,26.56,26.56,0,0,0-1.54,3.74,24.48,24.48,0,0,1,3-3.4A22.92,22.92,0,0,1,829.35,607.49Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M891.09,491.54a22,22,0,0,1,.17-4.41,24.93,24.93,0,0,0-4.78,6.57,25.63,25.63,0,0,0-1.52,3.73A22.75,22.75,0,0,1,891.09,491.54Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M875.4,579.1a24.29,24.29,0,0,1-1,4.38,26.67,26.67,0,0,0,2.09-3.44,25.49,25.49,0,0,0,1.63-4A24.23,24.23,0,0,1,875.4,579.1Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M860.32,608.92a24.15,24.15,0,0,1-1,4.38,25.65,25.65,0,0,0,2.1-3.44,26.47,26.47,0,0,0,1.63-4A23.57,23.57,0,0,1,860.32,608.92Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M867.86,594a24.11,24.11,0,0,1-1,4.38A26.67,26.67,0,0,0,869,595a25.49,25.49,0,0,0,1.63-4A24.23,24.23,0,0,1,867.86,594Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M882.94,564.19a24,24,0,0,1-1,4.37,25.89,25.89,0,0,0,2.09-3.43,25.48,25.48,0,0,0,1.64-4.07A23.22,23.22,0,0,1,882.94,564.19Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M833.57,526.48c7.72-2.53,16.68,3.66,20,13.83a25.68,25.68,0,0,1,1,4.51,21.18,21.18,0,0,1,4.44,4.73,25.53,25.53,0,0,1,2.08-5.75c.35-.68.73-1.33,1.12-2a21.07,21.07,0,0,0-4-4.18,25.38,25.38,0,0,0-1-4.5c-3.34-10.17-12.3-16.37-20-13.83-4.4,1.44-7.44,5.41-8.62,10.43A11.69,11.69,0,0,1,833.57,526.48Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M869.37,534.48a21.85,21.85,0,0,1,.18-4.4,24.73,24.73,0,0,0-4.79,6.57,25.07,25.07,0,0,0-1.52,3.72A23,23,0,0,1,869.37,534.48Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M880.23,513a21.85,21.85,0,0,1,.18-4.4,24.52,24.52,0,0,0-4.79,6.56,25.63,25.63,0,0,0-1.52,3.73A22.75,22.75,0,0,1,880.23,513Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M852.78,623.83a24.25,24.25,0,0,1-1,4.39,25.73,25.73,0,0,0,3.73-7.49A23.57,23.57,0,0,1,852.78,623.83Z",
                transform: "translate(-88.65 -57.09)"
              }
            })
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M948.52,430.71a23.68,23.68,0,0,0,8.23-9.32c4.91-9.7,2.88-20.61-4.53-24.36s-17.4,1.08-22.31,10.79A23.68,23.68,0,0,0,927.29,420a24.63,24.63,0,0,0-10.86,21.47,23.61,23.61,0,0,0-8.23,9.32,24.69,24.69,0,0,0-1.51,3.69,20.85,20.85,0,0,1,10.77-8A12.24,12.24,0,0,0,933,454.32a20.85,20.85,0,0,1,0,13.41,25.48,25.48,0,0,0,2.08-3.4,23.68,23.68,0,0,0,2.62-12.15,24.57,24.57,0,0,0,10.86-21.47Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#3f3d56"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M1067.88,293.07a72,72,0,0,0,8.72-4.83l-32.33-23.62,38,19.57a72.13,72.13,0,0,0,27-50.31l-64.58.66,64.72-10.82A72,72,0,1,0,966.83,242a72.09,72.09,0,0,0-13.26,8l33.75,46.93L946.8,255.85a72.08,72.08,0,0,0-20.17,65.61,72,72,0,1,0,101.05,51.1,72,72,0,0,0,40.2-79.49Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#4299e1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M933,274.75a71.77,71.77,0,0,0-6.35,46.71,72,72,0,1,0,101.05,51.1C1041.83,366,936.62,267.54,933,274.75Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "925.49", cy: "102.72", r: "10.69", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "987.93", cy: "109.58", r: "10.69", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "1012.01", cy: "205.64", r: "10.69", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "979.51", cy: "253.61", r: "10.69", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "935.11", cy: "353.24", r: "10.69", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "935.11", cy: "353.24", r: "10.69", opacity: "0.1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "836.39", cy: "240.4", r: "10.69", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "836.39", cy: "240.4", r: "10.69", opacity: "0.1" }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M913.64,473.32c-7.11-3.59-9.26-13.76-5.11-23.14-.22.38-.43.77-.63,1.18-4.91,9.7-2.88,20.6,4.53,24.35s17.4-1.08,22.3-10.78c.21-.4.39-.81.57-1.21C930.21,472.63,920.74,476.92,913.64,473.32Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M903.08,494.2c-7.1-3.59-9.26-13.76-5.1-23.15-.22.39-.44.78-.64,1.18-4.91,9.7-2.88,20.61,4.53,24.35s17.4-1.07,22.31-10.78c.2-.4.39-.8.57-1.21C919.65,493.5,910.19,497.79,903.08,494.2Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M892.52,515.07c-7.1-3.59-9.26-13.76-5.1-23.14-.22.38-.44.77-.64,1.18-4.91,9.7-2.87,20.6,4.54,24.35s17.39-1.08,22.3-10.78c.2-.4.39-.81.57-1.21C909.1,514.38,899.63,518.67,892.52,515.07Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M882,536c-7.11-3.59-9.26-13.76-5.11-23.14-.22.38-.43.77-.64,1.17-4.9,9.7-2.87,20.61,4.54,24.36s17.4-1.08,22.3-10.79c.21-.4.39-.8.57-1.21C898.54,535.25,889.07,539.54,882,536Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M871.41,556.82c-7.11-3.59-9.26-13.76-5.11-23.14-.22.38-.43.77-.63,1.18-4.91,9.7-2.88,20.6,4.53,24.35s17.4-1.08,22.31-10.78c.2-.4.39-.81.57-1.21C888,556.13,878.51,560.42,871.41,556.82Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M860.85,577.7c-7.1-3.59-9.26-13.76-5.1-23.14-.22.38-.44.77-.64,1.17-4.91,9.7-2.88,20.61,4.54,24.36S877,579,882,569.3c.2-.4.39-.8.57-1.21C877.42,577,868,581.29,860.85,577.7Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M850.29,598.57c-7.1-3.59-9.26-13.76-5.1-23.14-.22.39-.43.77-.64,1.18-4.9,9.7-2.87,20.6,4.54,24.35s17.4-1.08,22.3-10.78c.21-.4.39-.81.57-1.21C866.87,597.88,857.4,602.17,850.29,598.57Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M839.74,619.45c-7.11-3.59-9.26-13.76-5.11-23.14q-.33.57-.63,1.17c-4.91,9.7-2.88,20.61,4.53,24.36s17.4-1.08,22.31-10.79c.2-.4.38-.8.56-1.21C856.31,618.75,846.84,623,839.74,619.45Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M832.8,633.17c-7.1-3.6-9.26-13.76-5.1-23.15-.22.39-.44.78-.64,1.18-4.91,9.7-2.88,20.61,4.53,24.35s17.4-1.07,22.31-10.78c.2-.4.39-.8.57-1.21C849.37,632.47,839.9,636.76,832.8,633.17Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M1023.59,540.26a37.4,37.4,0,0,0,2-9.79,5.34,5.34,0,1,0-.81-10.62,37.31,37.31,0,0,0-19.64-25.31,5.34,5.34,0,1,0-9.54-4.82,5,5,0,0,0-.48,1.43A37.49,37.49,0,0,0,962.25,501a37.64,37.64,0,0,0-9.82-.29l-4.33,19.71-.26-19a37.42,37.42,0,1,0,20,72,5.28,5.28,0,0,0,2.25,2.16,5.34,5.34,0,0,0,7.32-6.88,37.35,37.35,0,0,0,4.8-3.92,37.45,37.45,0,0,0,39.31-19.83l-20.15-3.39Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#4299e1"
            }
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.1" } }, [
            _c("path", {
              attrs: {
                d:
                  "M992.46,549.83c-7.44-9.82-12-21.45-17.25-32.61a136.38,136.38,0,0,0-7.07-13.36l-3.94-4.59c-.66.56-1.32,1.14-2,1.75a37.64,37.64,0,0,0-9.82-.29l-4.33,19.71-.26-19a37.42,37.42,0,1,0,20,72,5.28,5.28,0,0,0,2.25,2.16,5.34,5.34,0,0,0,7.32-6.88,37.35,37.35,0,0,0,4.8-3.92,37.49,37.49,0,0,0,22.44-3.32A52.71,52.71,0,0,1,992.46,549.83Z",
                transform: "translate(-88.65 -57.09)"
              }
            })
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M860.71,507.63a5.34,5.34,0,0,0-4.78-7.75,37.37,37.37,0,0,0-11.7-20.83,37.52,37.52,0,0,0,1.1-11.7L825.68,464l19.08-1.2a38,38,0,0,0-1.41-5.28,5.46,5.46,0,0,0,1.76-2,5.35,5.35,0,0,0-6.59-7.44A37.42,37.42,0,0,0,771.73,479a5.25,5.25,0,0,0-2.66,2.5,5.34,5.34,0,0,0,6.75,7.37,37.53,37.53,0,0,0,7.09,8.65,37.4,37.4,0,0,0,1.74,23.76L811,514.44,787.5,526.8a37.42,37.42,0,0,0,68.91-16.26A5.33,5.33,0,0,0,860.71,507.63Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#4299e1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M860.71,507.63a5.34,5.34,0,0,0-4.78-7.75,37.37,37.37,0,0,0-11.7-20.83c.16-.63.3-1.25.42-1.88a13.18,13.18,0,0,0-1.93,1.71c-3.55,3.89-5.37,9.12-8.88,13.05-4.14,4.64-10.34,7.06-16.53,7.71s-12.42-.3-18.53-1.49c-5.06-1-10.19-2.16-15.32-1.67-.5,0-1,.11-1.46.19.3.29.6.58.91.86a37.4,37.4,0,0,0,1.74,23.76L811,514.44,787.5,526.8a37.42,37.42,0,0,0,68.91-16.26A5.33,5.33,0,0,0,860.71,507.63Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          })
        ]),
        _vm._v(" "),
        _c("g", { attrs: { opacity: "0.1" } }, [
          _c("path", {
            attrs: {
              d:
                "M178.14,568.33c1.28-3.89,6.47-5.68,11.59-4a12.78,12.78,0,0,1,2.13.92c.33-.09.67-.17,1-.23a11.26,11.26,0,0,1-.32-3.42,12.46,12.46,0,0,1-5.47-10.82,11.92,11.92,0,0,1-4.14-4.69,12,12,0,0,1-1.33-6.12,12,12,0,0,1-4.14-4.7C175,530.39,176,524.9,179.75,523s8.77.55,11.24,5.43a12,12,0,0,1,1.32,6.13,12.37,12.37,0,0,1,5.47,10.81,12.4,12.4,0,0,1,5.47,10.82A12.37,12.37,0,0,1,208.72,567a12,12,0,0,1,4.15,4.7,12.66,12.66,0,0,1,1,2.9,10.66,10.66,0,0,1,2.23-2.39,12.58,12.58,0,0,1,.52-2.27c1.69-5.12,6.2-8.24,10.09-7s5.67,6.47,4,11.59a11.67,11.67,0,0,1-3.81,5.59,12.67,12.67,0,0,1-.52,2.26,11.1,11.1,0,0,1-5.11,6.42,12.84,12.84,0,0,1,.42,2,12.57,12.57,0,0,1,2.53,3.43,12.32,12.32,0,0,1,1.26,4.08,12.55,12.55,0,0,1,2.54,3.43,12.39,12.39,0,0,1,1.26,4.08,12.45,12.45,0,0,1,2.54,3.44c2.47,4.88,1.45,10.38-2.28,12.26s-8.77-.54-11.24-5.43a12.48,12.48,0,0,1-1.26-4.08,12.7,12.7,0,0,1-3.8-7.51,12.7,12.7,0,0,1-3.8-7.51,12.6,12.6,0,0,1-2.54-3.43,12.73,12.73,0,0,1-1.26-4.08,12.57,12.57,0,0,1-2.53-3.43,12.32,12.32,0,0,1-1.26-4.08,11.63,11.63,0,0,1-1.71-2,11.9,11.9,0,0,1-6.18-.38,13.29,13.29,0,0,1-2.14-.93,11.61,11.61,0,0,1-6.75-.24C180,576.73,176.87,572.22,178.14,568.33Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#3f3d56"
            }
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.1" } }, [
            _c("path", {
              attrs: {
                d:
                  "M187.17,553a10.72,10.72,0,0,0,1.74,1.39,11.31,11.31,0,0,0,.56,4.24,11.93,11.93,0,0,1-1.06-1.73A12.46,12.46,0,0,1,187.17,553Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M181.7,542.2a11.21,11.21,0,0,0,1.74,1.38,11.39,11.39,0,0,0,.56,4.25,12.7,12.7,0,0,1-2.3-5.63Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M194.13,538.17a11.11,11.11,0,0,0-.08-2.22,12.66,12.66,0,0,1,2.41,3.31,13,13,0,0,1,.76,1.88A11.42,11.42,0,0,0,194.13,538.17Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M228.83,603.63a11.65,11.65,0,0,0-1.48-1.7,12.4,12.4,0,0,0-.44-2,13.23,13.23,0,0,1,1.15,1.86A13,13,0,0,1,228.83,603.63Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M225,596.12a11.65,11.65,0,0,0-1.48-1.7,11.75,11.75,0,0,0-.42-2h0a12.67,12.67,0,0,1,1.88,3.68Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M192.65,563.84a10.11,10.11,0,0,0,1.73,1.37,10.9,10.9,0,0,0,.32,3.42,10,10,0,0,0-1,.23,13.26,13.26,0,0,0-2.14-.92c-5.12-1.68-10.31.11-11.58,4a5.82,5.82,0,0,0-.17,3,6.93,6.93,0,0,1-1.66-6.61c1.28-3.89,6.47-5.68,11.59-4a12.78,12.78,0,0,1,2.13.92c.33-.09.67-.17,1-.23A10.32,10.32,0,0,1,192.65,563.84Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M230.71,607.4a12.79,12.79,0,0,1,1.15,1.87,13,13,0,0,1,.77,1.88,11.74,11.74,0,0,0-1.48-1.71A12.4,12.4,0,0,0,230.71,607.4Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M199.6,549a11.08,11.08,0,0,0-.08-2.22,12.49,12.49,0,0,1,2.41,3.31,12.87,12.87,0,0,1,.76,1.87A11.38,11.38,0,0,0,199.6,549Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M207.51,593.1a11.94,11.94,0,0,0,.49,2.2,12.63,12.63,0,0,1-1.88-3.77A11.72,11.72,0,0,0,207.51,593.1Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M215.1,608.12a12.66,12.66,0,0,0,.5,2.2,11.93,11.93,0,0,1-1.06-1.73,12.88,12.88,0,0,1-.82-2A13,13,0,0,0,215.1,608.12Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M211.31,600.61a11.94,11.94,0,0,0,.49,2.2,12.88,12.88,0,0,1-1.06-1.73,12.6,12.6,0,0,1-.82-2A11.72,11.72,0,0,0,211.31,600.61Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M203.71,585.58a11.86,11.86,0,0,0,.49,2.21,12.44,12.44,0,0,1-1-1.73,12.23,12.23,0,0,1-.83-2A11.13,11.13,0,0,0,203.71,585.58Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M228.58,566.59c-3.89-1.28-8.4,1.84-10.08,7a12.58,12.58,0,0,0-.52,2.27,10.63,10.63,0,0,0-2.24,2.38,12.83,12.83,0,0,0-1.05-2.9c-.17-.34-.36-.67-.56-1a10.63,10.63,0,0,1,2-2.1,12.58,12.58,0,0,1,.52-2.27c1.69-5.12,6.2-8.24,10.09-7a6.93,6.93,0,0,1,4.34,5.26A5.93,5.93,0,0,0,228.58,566.59Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M210.54,570.62a11.11,11.11,0,0,0-.08-2.22,12.49,12.49,0,0,1,2.41,3.31,13,13,0,0,1,.76,1.88A11.28,11.28,0,0,0,210.54,570.62Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M205.07,559.8a11.13,11.13,0,0,0-.08-2.22,12.83,12.83,0,0,1,2.41,3.31,13,13,0,0,1,.76,1.88A11.42,11.42,0,0,0,205.07,559.8Z",
                transform: "translate(-88.65 -57.09)"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M218.9,615.63a11.9,11.9,0,0,0,.5,2.21,12.61,12.61,0,0,1-1.06-1.74,12.88,12.88,0,0,1-.82-2A13,13,0,0,0,218.9,615.63Z",
                transform: "translate(-88.65 -57.09)"
              }
            })
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M170.67,518.34a11.92,11.92,0,0,1-4.14-4.69c-2.47-4.89-1.45-10.38,2.28-12.27s8.77.54,11.24,5.43a11.93,11.93,0,0,1,1.32,6.12,12.4,12.4,0,0,1,5.47,10.82,12,12,0,0,1,4.15,4.69,13.23,13.23,0,0,1,.76,1.86,10.57,10.57,0,0,0-5.43-4,6.16,6.16,0,0,1-7.83,4,10.52,10.52,0,0,0,0,6.75,13.19,13.19,0,0,1-1-1.71,12,12,0,0,1-1.33-6.12,12.43,12.43,0,0,1-5.47-10.82Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#3f3d56"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M110.55,449a36.81,36.81,0,0,1-4.39-2.43l16.28-11.9-19.14,9.85a36.34,36.34,0,0,1-13.59-25.34l32.54.34-32.61-5.46a36.29,36.29,0,1,1,71.81,9.2,36.73,36.73,0,0,1,6.68,4l-17,23.64,20.41-20.68a36.32,36.32,0,0,1,10.16,33.05,36.29,36.29,0,1,1-50.9,25.74,36.28,36.28,0,0,1-20.25-40Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#4299e1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M178.5,439.78a36.12,36.12,0,0,1,3.2,23.53,36.29,36.29,0,1,1-50.9,25.74C123.67,485.74,176.67,436.15,178.5,439.78Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "48.97", cy: "324.78", r: "5.39", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "17.51", cy: "328.24", r: "5.39", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "5.39", cy: "376.63", r: "5.39", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "21.76", cy: "400.8", r: "5.39", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "44.12", cy: "450.99", r: "5.39", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "44.12", cy: "450.99", r: "5.39", opacity: "0.1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "93.85", cy: "394.14", r: "5.39", fill: "#4299e1" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "93.85", cy: "394.14", r: "5.39", opacity: "0.1" }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M188.25,539.81c3.58-1.81,4.66-6.93,2.57-11.66.11.2.22.39.32.59,2.47,4.89,1.45,10.38-2.29,12.27s-8.76-.54-11.23-5.43c-.1-.2-.2-.4-.29-.61C179.9,539.46,184.67,541.62,188.25,539.81Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M193.56,550.33c3.58-1.81,4.67-6.94,2.58-11.66.11.19.22.39.32.59,2.47,4.89,1.45,10.38-2.29,12.27s-8.76-.54-11.23-5.43c-.11-.2-.2-.41-.29-.61C185.22,550,190,552.14,193.56,550.33Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M198.88,560.84c3.58-1.81,4.67-6.93,2.57-11.66.12.2.22.39.33.6,2.47,4.88,1.44,10.38-2.29,12.26s-8.76-.54-11.23-5.43c-.11-.2-.2-.4-.29-.61C190.53,560.49,195.3,562.65,198.88,560.84Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M204.2,571.36c3.58-1.81,4.67-6.93,2.57-11.66.11.19.22.39.32.59,2.48,4.89,1.45,10.38-2.28,12.27s-8.77-.54-11.24-5.43c-.1-.2-.19-.41-.28-.61C195.85,571,200.62,573.17,204.2,571.36Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M209.52,581.87c3.58-1.81,4.66-6.93,2.57-11.65.11.19.22.39.32.59,2.47,4.89,1.45,10.38-2.28,12.27s-8.77-.55-11.24-5.43c-.1-.21-.19-.41-.29-.61C201.17,581.52,205.94,583.68,209.52,581.87Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M214.84,592.39c3.58-1.81,4.66-6.93,2.57-11.66.11.2.22.39.32.59,2.47,4.89,1.45,10.38-2.28,12.27s-8.77-.54-11.24-5.43c-.1-.2-.2-.4-.29-.61C206.49,592,211.26,594.2,214.84,592.39Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M220.16,602.91c3.57-1.81,4.66-6.94,2.57-11.66.11.19.22.39.32.59,2.47,4.89,1.45,10.38-2.29,12.27s-8.76-.55-11.23-5.43c-.1-.21-.2-.41-.29-.61C211.81,602.55,216.58,604.72,220.16,602.91Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M225.47,613.42c3.58-1.81,4.67-6.93,2.57-11.66.12.2.22.39.33.6,2.47,4.88,1.44,10.38-2.29,12.26s-8.76-.54-11.23-5.43c-.11-.2-.2-.4-.29-.61C217.13,613.07,221.89,615.23,225.47,613.42Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M229,620.33c3.58-1.81,4.66-6.93,2.57-11.66.11.2.22.39.32.6,2.47,4.88,1.45,10.38-2.28,12.26s-8.77-.54-11.24-5.43c-.1-.2-.2-.4-.29-.61C220.62,620,225.39,622.14,229,620.33Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M132.86,573.53a18.57,18.57,0,0,1-1-4.93,2.69,2.69,0,1,1,.41-5.35,18.82,18.82,0,0,1,9.89-12.75,2.69,2.69,0,1,1,4.81-2.43,2.44,2.44,0,0,1,.24.72,18.92,18.92,0,0,1,16.56,5,18.68,18.68,0,0,1,5-.14l2.18,9.92L171,554a18.85,18.85,0,1,1-10.08,36.29,2.76,2.76,0,0,1-1.13,1.09,2.7,2.7,0,0,1-3.7-3.47,18.84,18.84,0,0,1-2.41-2,18.87,18.87,0,0,1-19.8-10l10.15-1.71Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#4299e1"
            }
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.1" } }, [
            _c("path", {
              attrs: {
                d:
                  "M148.54,578.35c3.75-5,6.05-10.8,8.69-16.42a66.7,66.7,0,0,1,3.56-6.74l2-2.31c.34.29.67.58,1,.88a18.68,18.68,0,0,1,5-.14l2.18,9.92L171,554a18.85,18.85,0,1,1-10.08,36.29,2.76,2.76,0,0,1-1.13,1.09,2.7,2.7,0,0,1-3.7-3.47,18.84,18.84,0,0,1-2.41-2,19,19,0,0,1-11.31-1.67A26.59,26.59,0,0,0,148.54,578.35Z",
                transform: "translate(-88.65 -57.09)"
              }
            })
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M214.91,557.09a2.68,2.68,0,0,1,1.19-3.61,2.64,2.64,0,0,1,1.22-.29,18.85,18.85,0,0,1,5.89-10.5,18.71,18.71,0,0,1-.55-5.89l9.89-1.66-9.61-.61a18.65,18.65,0,0,1,.72-2.66,2.64,2.64,0,0,1-.89-1,2.7,2.7,0,0,1,3.32-3.75,18.63,18.63,0,0,1,6.87-5.93,18.84,18.84,0,0,1,26.77,21.5,2.69,2.69,0,0,1,.16,4.87,2.7,2.7,0,0,1-2.22.1A18.74,18.74,0,0,1,254.1,552a18.9,18.9,0,0,1-.87,12L240,560.52l11.83,6.23A18.86,18.86,0,0,1,219,565.21a19.11,19.11,0,0,1-1.94-6.65A2.67,2.67,0,0,1,214.91,557.09Z",
              transform: "translate(-88.65 -57.09)",
              fill: "#4299e1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M214.91,557.09a2.68,2.68,0,0,1,1.19-3.61,2.64,2.64,0,0,1,1.22-.29,18.85,18.85,0,0,1,5.89-10.5c-.08-.31-.15-.63-.21-.94a7.27,7.27,0,0,1,1,.86c1.79,2,2.71,4.59,4.47,6.57a12.91,12.91,0,0,0,8.33,3.89,31.54,31.54,0,0,0,9.33-.75,27.35,27.35,0,0,1,7.72-.85l.74.1-.46.43a18.9,18.9,0,0,1-.87,12L240,560.52l11.83,6.23A18.86,18.86,0,0,1,219,565.21a19.11,19.11,0,0,1-1.94-6.65A2.67,2.67,0,0,1,214.91,557.09Z",
              transform: "translate(-88.65 -57.09)",
              opacity: "0.1"
            }
          })
        ]),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M435,109a20.23,20.23,0,0,0-11.74,1.28,17.32,17.32,0,0,1-14.1,0,19.76,19.76,0,0,0-16.58.33,10.28,10.28,0,0,1-4.77,1.19c-6.72,0-12.31-6.77-13.47-15.7a13.07,13.07,0,0,0,3.36-3.62c3.94-6.35,10-10.43,16.89-10.43s12.89,4,16.83,10.31a13,13,0,0,0,11.16,6.14h.18C428.06,98.47,432.69,102.76,435,109Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M455.42,81l-10.86,6.89,6.59-12a10.74,10.74,0,0,0-6.57-2.34h-.17a12.89,12.89,0,0,1-2.25-.17l-3.69,2.34,1.58-2.87A13.19,13.19,0,0,1,433.61,68L427,72.13l4.16-7.57c-3.85-4.63-9.05-7.47-14.76-7.47-6.85,0-13,4.08-16.9,10.43a12.62,12.62,0,0,1-11.17,6H388c-7.56,0-13.7,8.57-13.7,19.16s6.14,19.15,13.7,19.15a10.28,10.28,0,0,0,4.77-1.19,19.72,19.72,0,0,1,16.58-.32,17.37,17.37,0,0,0,14.1,0,19.75,19.75,0,0,1,16.43.32,10.35,10.35,0,0,0,4.72,1.16c7.57,0,13.7-8.57,13.7-19.15A24.36,24.36,0,0,0,455.42,81Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M209,247.54a29,29,0,0,0-16.77,1.82,24.71,24.71,0,0,1-20.14-.05,28.22,28.22,0,0,0-23.68.47,14.75,14.75,0,0,1-6.82,1.7c-9.6,0-17.59-9.67-19.25-22.43a18.41,18.41,0,0,0,4.8-5.17c5.63-9.07,14.35-14.9,24.14-14.9s18.4,5.76,24,14.73a18.52,18.52,0,0,0,16,8.77h.25C199.11,232.47,205.73,238.6,209,247.54Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M238.2,207.49l-15.52,9.84,9.42-17.13a15.34,15.34,0,0,0-9.39-3.35h-.25a18.16,18.16,0,0,1-3.22-.24L214,200l2.26-4.1a18.7,18.7,0,0,1-9.2-7l-9.42,6L203.57,184c-5.51-6.61-12.93-10.66-21.09-10.66-9.79,0-18.51,5.82-24.14,14.89a18.05,18.05,0,0,1-16,8.61h-.53c-10.81,0-19.57,12.25-19.57,27.37s8.76,27.37,19.57,27.37a14.61,14.61,0,0,0,6.82-1.71,28.22,28.22,0,0,1,23.68-.46,24.71,24.71,0,0,0,20.14.05,28.25,28.25,0,0,1,23.48.45,14.65,14.65,0,0,0,6.74,1.67c10.81,0,19.57-12.26,19.57-27.37A34.76,34.76,0,0,0,238.2,207.49Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M836.62,148a20.24,20.24,0,0,1,11.74,1.28,17.29,17.29,0,0,0,14.09,0,19.76,19.76,0,0,1,16.58.33,10.31,10.31,0,0,0,4.77,1.19c6.72,0,12.32-6.77,13.48-15.7a12.93,12.93,0,0,1-3.36-3.62C890,125.11,883.87,121,877,121s-12.88,4-16.82,10.31A13,13,0,0,1,849,137.48h-.17C843.51,137.47,838.87,141.76,836.62,148Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M816.14,120,827,126.87l-6.6-12a10.76,10.76,0,0,1,6.57-2.34h.18a13,13,0,0,0,2.25-.17l3.68,2.34-1.58-2.87A13.21,13.21,0,0,0,838,107l6.59,4.18-4.17-7.57c3.86-4.63,9-7.47,14.77-7.47,6.85,0,13,4.08,16.9,10.43a12.61,12.61,0,0,0,11.17,6h.36c7.57,0,13.7,8.57,13.7,19.16s-6.13,19.15-13.7,19.15a10.34,10.34,0,0,1-4.77-1.19,19.72,19.72,0,0,0-16.58-.32,17.35,17.35,0,0,1-14.09,0,19.77,19.77,0,0,0-16.44.32,10.32,10.32,0,0,1-4.72,1.16c-7.56,0-13.7-8.57-13.7-19.15A24.36,24.36,0,0,1,816.14,120Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("ellipse", {
          attrs: {
            cx: "615.63",
            cy: "756.88",
            rx: "115",
            ry: "20",
            fill: "#4299e1",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("polygon", {
          attrs: {
            points:
              "555.44 661.88 377.25 659.59 377.78 655.02 386.39 579.63 542.88 579.63 554.39 655.02 555.27 660.74 555.44 661.88",
            fill: "#d0d2d5"
          }
        }),
        _vm._v(" "),
        _c("polygon", {
          attrs: {
            points:
              "555.27 660.74 466.35 660.74 377.25 659.59 377.78 655.02 554.39 655.02 555.27 660.74",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "347.55",
            y: "656.17",
            width: "236.45",
            height: "5.71",
            fill: "#d0d2d5"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M898.24,183.92A14.87,14.87,0,0,0,883.44,169H223.12a14.87,14.87,0,0,0-14.8,14.94V584.19H898.24Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#3f3d56"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M208.32,580.19v46.88a14.8,14.8,0,0,0,14.8,14.8H883.44a14.8,14.8,0,0,0,14.8-14.8V580.19Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#d0d2d5"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "148.23",
            y: "137.01",
            width: "636.23",
            height: "359.81",
            fill: "#fff"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M556.71,624.08a15.4,15.4,0,0,0,12.13-5.89h0a16.06,16.06,0,0,0,1.2-1.76L561.57,615l9.15.06a15.42,15.42,0,0,0,.29-12.21l-12.27,6.36,11.32-8.32a15.42,15.42,0,1,0-25.47,17.26h0A15.4,15.4,0,0,0,556.71,624.08Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1"
          }
        }),
        _c("polygon", {
          attrs: {
            points: "483.48 584.77 554.57 656.17 543.66 584.77 483.48 584.77",
            opacity: "0.1"
          }
        }),
        _c("rect", {
          attrs: {
            x: "147.73",
            y: "137.05",
            width: "636.92",
            height: "21.02",
            fill: "#444053",
            opacity: "0.1"
          }
        }),
        _c("rect", {
          attrs: {
            x: "368.87",
            y: "140.71",
            width: "191.9",
            height: "12.79",
            rx: "0.58",
            fill: "#4299e1",
            opacity: "0.3"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M643.72,205.52h-.47l-.17-.15a3.89,3.89,0,0,0,.9-2.49,3.78,3.78,0,1,0-3.77,3.81,3.9,3.9,0,0,0,2.49-.91l.17.15v.47l2.93,2.93.87-.88Zm-3.51,0a2.64,2.64,0,1,1,2.63-2.64A2.62,2.62,0,0,1,640.21,205.52Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#3f3d56"
          }
        }),
        _c("circle", {
          attrs: {
            cx: "159.18",
            cy: "147.56",
            r: "3.85",
            fill: "#fa5959",
            opacity: "0.8"
          }
        }),
        _c("circle", {
          attrs: {
            cx: "169.77",
            cy: "147.56",
            r: "3.85",
            fill: "#fed253",
            opacity: "0.8"
          }
        }),
        _c("circle", {
          attrs: {
            cx: "180.37",
            cy: "147.56",
            r: "3.85",
            fill: "#8ccf4d",
            opacity: "0.8"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M588.7,348.49c-8.73-11.6-21.38-18.92-35.46-18.92s-26.73,7.32-35.46,18.92a38.39,38.39,0,0,0,8.4,12.65,38.28,38.28,0,0,0,62.52-12.65Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M513.17,355.28a9.17,9.17,0,0,1-1.76-1,7.06,7.06,0,0,1-1.94-2.51,7.18,7.18,0,1,0-11.72,1.74,8,8,0,0,0,1.7,1.37,4.94,4.94,0,0,1,1.91,2,14.44,14.44,0,0,0,3.32,4.36,29,29,0,0,0,4.55,3.2A66.31,66.31,0,0,0,505.49,384a27.05,27.05,0,0,0-7.62,1.23,12.29,12.29,0,0,0-3.53,1.76,8.48,8.48,0,0,0-.87-.06,7.19,7.19,0,1,0,6.73,9.72,4.59,4.59,0,0,1,3.71-3,16.75,16.75,0,0,1,1.85-.12,64.4,64.4,0,0,0,8.55,26.67c-4.24,3.29-6.85,6.88-7.95,10.86a3,3,0,0,0-.57.41,6.81,6.81,0,0,0-.84.78A7.18,7.18,0,1,0,517,434.6a4.71,4.71,0,0,1,1.17-5.08c.48-.45,1-.93,1.7-1.46,8.11,9.47,17.76,15.54,29.81,16.26V380.07C533.75,379.2,519.87,368.83,513.17,355.28ZM613,387a7.93,7.93,0,0,0-.87.06,13.56,13.56,0,0,0-3.53-1.76,26.86,26.86,0,0,0-7.62-1.23,67.76,67.76,0,0,0-3.74-19.55,29,29,0,0,0,4.55-3.2,15.58,15.58,0,0,0,3.44-4.57A4.22,4.22,0,0,1,607,355a0,0,0,0,0,0,0,7.18,7.18,0,1,0-10-3.17,6.82,6.82,0,0,1-1.94,2.51,18.85,18.85,0,0,1-1.76,1.29c-6.7,13.54-20.57,23.62-36.48,24.49v64.31c12-.72,21.71-6.82,29.81-16.26.63.5,1.16.95,1.61,1.37a4.86,4.86,0,0,1,1.26,5.23,7.18,7.18,0,1,0,12.08-2.33,6.81,6.81,0,0,0-.84-.78c-.33-.26-.57-.41-.57-.41-1.1-4-3.7-7.57-8-10.86a64.4,64.4,0,0,0,8.55-26.67,15.9,15.9,0,0,1,1.77.12,4.8,4.8,0,0,1,3.85,3,7.18,7.18,0,0,0,13.85-2.18A7.29,7.29,0,0,0,613,387Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M769.65,802.31a9.56,9.56,0,0,0-2.17-2.41c-4.37-4.13-6.4-10.19-7.48-16.13s-1.39-12-3.12-17.81a58.74,58.74,0,0,0-3.52-8.67c-1-2.14-2.26-6.33-4.09-7.83a2.7,2.7,0,0,0-1.26-.61,14.85,14.85,0,0,0-3.62-4.82c-2.86-2.59-6.35-4.65-8.26-8a18,18,0,0,0-1.93-3.29c-1.29-1.42-3.33-2-4.52-3.5-1.55-1.94-1.2-4.72-1-7.19s0-5.43-2.14-6.73c-1.28-.79-2.93-.71-4.26-1.41-2-1-2.79-3.52-2.75-5.77s.74-4.44.92-6.69c.56-7.16-4.16-14.28-2.34-21.22.69-2.63,2.27-4.91,3.44-7.36a15.37,15.37,0,0,0,1-2.54,35.73,35.73,0,0,0,9.74,2.35c-5.51-12.36-4.11-26.72-6.68-40l.33-.45a20.84,20.84,0,0,0,4.22-11.86c0-4.94-2.31-9.56-3.35-14.4-.89-4.11-.85-8.41-2-12.45a37.65,37.65,0,0,0-3.16-7.22q-1.87-3.47-3.93-6.83-1.92-6.36-3.85-12.72c-1.8-5.95-3.65-12-7.15-17.14-1.28-1.88-1.67-5.7-3.64-6.84a8.81,8.81,0,0,0-5.2-.91c-2.78-1.56-5.22-3.81-5.57-6.89a6.68,6.68,0,0,1,.2-2l.34,0c4.4-.4,6.63-4.28,8.92-7.68,3.7-5.5,2.29-12.94,0-19.2a13,13,0,0,0-3-5.29c-3.21-3-8.29-2.34-12.43-3.79-1.39-.48-2.69-1.21-4.11-1.55-2.75-.64-5.63.26-8.15,1.53s-4.87,2.91-7.51,3.91-5.9,1.79-6.55,4.5a5,5,0,0,0,.22,2.73,10.18,10.18,0,0,0,3.09,4.46,17.81,17.81,0,0,0,10.87,24.82c.76,1.22,1.47,2.46,2.12,3.73,1.16,2.24,2.14,4.88,1.74,7.28a22.45,22.45,0,0,0-2,2.45c-2.87,4-4.5,8.69-6,13.37a141.65,141.65,0,0,0-4.83,18.27c-2.44,5.19-5.42,10.15-7.19,15.6a35.21,35.21,0,0,1-9.38-1.26l-8.44-1.91c-2.94-.67-6-1.39-8.3-3.33-1.22-1-2.17-2.33-3.41-3.32s-3.73-2.15-5.09-1.33a4,4,0,0,0-.69.53c-1.24-2.51-2.42-5-3.86-7.43-2.07-3.4-5.15-6.51-9.05-7.16a9.21,9.21,0,0,0-6.79,1.58c-2.28,1.62-3.71,5-2,7.28a13.29,13.29,0,0,0,1.39,1.42,29.2,29.2,0,0,1,3.09,4.29A21.91,21.91,0,0,0,619,596.23l-.35,1c-.71,2.08-2.22,4.59-1.84,6.75l37.54,12.85a23.13,23.13,0,0,0,7.56,1.67,12.21,12.21,0,0,0,3-.4l0,1.92v.08c.1,13.19-2,26.29-2.39,39.47-.07,2.41,0,5,1.52,6.88,1.7,2.06,4.72,2.47,7.35,2q.95-.16,1.86-.42a69.33,69.33,0,0,1,1.92,10.11L677.65,696a27.14,27.14,0,0,1,.39,5.54c-.29,4.19-2.5,7.94-4.1,11.81s-2.55,8.5-.45,12.12c.66,1.12,1.57,2.07,2.16,3.23a13.14,13.14,0,0,1,1,5.68q.23,8.08.44,16.18a1.83,1.83,0,0,0-1.26.25c-2.08,1.62-1.85,9.33-2,11.72-.16,4,0,8.08-.22,12.12A72.22,72.22,0,0,1,671,790.74a10.29,10.29,0,0,1-2.29,4.61,9.74,9.74,0,0,1-4.07,2.11,46.49,46.49,0,0,1-15.41,2.1c-2.11-.07-4.31-.27-6.27.53s-3.54,3-2.83,5c.61,1.68,2.46,2.48,4.13,3.11a65.53,65.53,0,0,1,11,5.06,29.74,29.74,0,0,0,4.25,2.41,21.91,21.91,0,0,0,4.38,1.08l17.73,3.06c3.63.62,8,1,10.31-2,1.25-1.62,1.43-3.82,1.37-5.88-.1-4-.9-8.07-.38-12.07a37.14,37.14,0,0,1,1.86-6.93q2.65-7.87,5.32-15.73c1.78-5.26,3.58-10.57,4.27-16.09.25-2,.23-4.28-1.3-5.53a3.54,3.54,0,0,0-1.32-.68c-.06-4.82-.69-9.65-.42-14.47.07-1.2.19-2.4.29-3.61a17.61,17.61,0,0,1,2.47,2.92c1.71,2.68,2.34,6.22,4.95,8,2.22,1.52,5.51,1.44,7.07,3.64a10.26,10.26,0,0,1,1.12,2.71,19.32,19.32,0,0,0,4,6.35,32,32,0,0,0,2.47,6.34q2.21,4.67,4.4,9.31a108.59,108.59,0,0,0,5,9.77,27.55,27.55,0,0,1,3.35,6.46c1.41,4.94-.89,10.36-4.53,14s-8.44,5.73-13.17,7.68a3.71,3.71,0,0,0-1.34.8,2.59,2.59,0,0,0-.61,1.74c0,2.31,1.9,4.29,4.08,5a15.26,15.26,0,0,0,6.83.25c12.78-1.55,25.52-4.67,36.82-10.88a13,13,0,0,0,4.39-3.39A5.13,5.13,0,0,0,769.65,802.31Z",
            transform: "translate(-88.65 -57.09)",
            fill: "url(#af83dc26-9572-4816-b7a1-1af4f72ff554)"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M715.64,578.06q3.2,4.91,6,10.06a37,37,0,0,1,3.17,7.17c1.16,4,1.13,8.27,2,12.35,1,4.8,3.34,9.38,3.34,14.3a20.56,20.56,0,0,1-4.22,11.76,55.82,55.82,0,0,1-8.82,9.1,187.62,187.62,0,0,1-12.48-61.21c-.1-2.9-.12-5.89.94-8.6.65-1.7,3.77-6.36,5.78-4.53.73.67.92,3.69,1.37,4.7A36.13,36.13,0,0,0,715.64,578.06Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#2f2e41"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M715.64,578.06q3.2,4.91,6,10.06a37,37,0,0,1,3.17,7.17c1.16,4,1.13,8.27,2,12.35,1,4.8,3.34,9.38,3.34,14.3a20.56,20.56,0,0,1-4.22,11.76,55.82,55.82,0,0,1-8.82,9.1,187.62,187.62,0,0,1-12.48-61.21c-.1-2.9-.12-5.89.94-8.6.65-1.7,3.77-6.36,5.78-4.53.73.67.92,3.69,1.37,4.7A36.13,36.13,0,0,0,715.64,578.06Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M452,441.63c-7.91,7.9-8.86,11.38-13.61,12.95S416.55,465,421.92,474.81l14.44,9.54.42.28,2.21,6.64-21.84,38.88s-36-16.46-39.53,7.89-1.29,31-2.24,44,.31,16.76-2.86,16.76-4.42-8.54-4.42-8.54-.2-.39-.55-1.12c-4.71-9.79-36.68-81.66,14.53-131.06,0,0,23.72-1.56,29.43-28.76,3.94-18.8,17.72-17.18,26.88-13.35a30.38,30.38,0,0,1,8.22,4.83,40.48,40.48,0,0,1,5.89,7C455.11,431.92,456.53,437.09,452,441.63Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#d0d2d5"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M436.78,484.63l2.21,6.64-21.84,38.88s-36-16.46-39.53,7.89-1.29,31-2.24,44,.31,16.76-2.86,16.76-4.42-8.54-4.42-8.54-.2-.39-.55-1.12c-1.59-12.16-9.65-83.29,19.57-79.51,0,0,23.71,11.08,27.5,6.66,3-3.5,16.32-23.63,21.74-31.89Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M452.5,427.74l-14.44,16.41s-16.77,22.44-20.25,21.49a16.23,16.23,0,0,0-3.17-.37,6.16,6.16,0,0,1-4-10.38c5.72-6,16.26-17.39,16.95-19.92s7.4-13.62,10.76-19.05a30.38,30.38,0,0,1,8.22,4.83A40.48,40.48,0,0,1,452.5,427.74Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M861.06,663.83c-2.45,4.9-15,23.28-20.49,31.31L838,698.92s-1,6.64-17.39-1.59S419.13,526.61,419.13,526.61l-2.61-7.84,19-28.45L857.59,653.39S864.23,657.5,861.06,663.83Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#454b69"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M840.57,695.14,838,698.92s-1,6.64-17.39-1.59S419.13,526.61,419.13,526.61l-2.61-7.84Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M608.29,589c-3.91-.64-8.25-.33-11.29,2.21a9.29,9.29,0,0,0-3.24,6.16c-.26,2.77,1.35,6.06,4.13,6.27a13.17,13.17,0,0,0,2-.13,29.89,29.89,0,0,1,5.24.44,21.39,21.39,0,0,0,18.23-7.36c2.39-3-.76-4.3-3.58-4.9C615.92,590.87,612.15,589.62,608.29,589Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#fbbebe"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M675.17,679.31l2.48,17.62a26.84,26.84,0,0,1,.38,5.51c-.29,4.15-2.5,7.87-4.09,11.71s-2.56,8.44-.45,12c.65,1.11,1.56,2.06,2.15,3.21a12.92,12.92,0,0,1,1,5.63l.68,25a157.33,157.33,0,0,0,23.18-.13,1.29,1.29,0,0,0,.84-.26,1.36,1.36,0,0,0,.29-.91c.34-5.85-.68-11.71-.35-17.56.12-2.14.42-4.27.46-6.42.12-8.71-4.18-17.24-2.88-25.85a57,57,0,0,1,1.6-6.43c4.11-15,3.24-30.76,2.33-46.25a1.09,1.09,0,0,0-.2-.7,1.06,1.06,0,0,0-.54-.29,28.45,28.45,0,0,0-25.78,4.9c-1.09.88-3.84,1.73-4.56,2.78-1,1.46.31,2.92.89,4.47A56.89,56.89,0,0,1,675.17,679.31Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#3f3d56"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M675.17,679.31l2.48,17.62a26.84,26.84,0,0,1,.38,5.51c-.29,4.15-2.5,7.87-4.09,11.71s-2.56,8.44-.45,12c.65,1.11,1.56,2.06,2.15,3.21a12.92,12.92,0,0,1,1,5.63l.68,25a157.33,157.33,0,0,0,23.18-.13,1.29,1.29,0,0,0,.84-.26,1.36,1.36,0,0,0,.29-.91c.34-5.85-.68-11.71-.35-17.56.12-2.14.42-4.27.46-6.42.12-8.71-4.18-17.24-2.88-25.85a57,57,0,0,1,1.6-6.43c4.11-15,3.24-30.76,2.33-46.25a1.09,1.09,0,0,0-.2-.7,1.06,1.06,0,0,0-.54-.29,28.45,28.45,0,0,0-25.78,4.9c-1.09.88-3.84,1.73-4.56,2.78-1,1.46.31,2.92.89,4.47A56.89,56.89,0,0,1,675.17,679.31Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M721.54,674c-1.17,2.43-2.74,4.69-3.44,7.3-1.82,6.89,2.89,14,2.33,21.06-.18,2.23-.87,4.4-.92,6.63s.77,4.71,2.75,5.74c1.33.68,3,.61,4.25,1.39,2.11,1.29,2.35,4.22,2.14,6.68s-.56,5.21,1,7.13c1.19,1.49,3.23,2.07,4.51,3.48a17.17,17.17,0,0,1,1.93,3.26c1.91,3.34,5.4,5.38,8.26,8s5.28,6.46,4,10.09c-.94,2.66-3.58,4.3-6.12,5.55a64.93,64.93,0,0,1-14.57,5.15,3.52,3.52,0,0,1-1.67.09,3.57,3.57,0,0,1-1.46-1c-2.95-2.89-6-5.92-7.36-9.81a10.07,10.07,0,0,0-1.12-2.68c-1.56-2.19-4.85-2.11-7.07-3.62-2.6-1.77-3.23-5.28-4.93-7.93s-4.19-4.23-6-6.56c-3.06-3.88-3.81-9.06-6-13.49-.93-1.88-2.12-3.64-2.86-5.6a30.58,30.58,0,0,1-1.37-7.24c-1.41-11.68-5-23.44-2.74-35,.5-2.54,1.27-5,1.59-7.62.55-4.53-.32-9.17.35-13.69a3.77,3.77,0,0,1,1.51-2.91,4,4,0,0,1,1.72-.35,117.28,117.28,0,0,1,17.78.4c3,.29,6.36.9,8.16,3.35,1.53,2.1,1.45,4.91,1.94,7.46.61,3.14,2.2,4.85,3.87,7.31S722.77,671.46,721.54,674Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#3f3d56"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M698.47,755.26c1.58,0,3.33-.1,4.55.9,1.52,1.25,1.54,3.54,1.3,5.49-.7,5.48-2.49,10.75-4.28,16l-5.32,15.61a36.65,36.65,0,0,0-1.86,6.88c-.52,4,.28,8,.38,12,0,2-.13,4.22-1.38,5.83-2.26,2.91-6.67,2.57-10.3,2l-17.71-3a21.07,21.07,0,0,1-4.38-1.07,30.61,30.61,0,0,1-4.25-2.39,65.42,65.42,0,0,0-11-5c-1.66-.62-3.52-1.41-4.12-3.08-.71-2,.87-4.2,2.83-5s4.15-.6,6.27-.54a47,47,0,0,0,15.4-2.08,9.74,9.74,0,0,0,4.06-2.1A10,10,0,0,0,671,791a70.17,70.17,0,0,0,2.68-16c.21-4,.07-8,.23-12,.1-2.37-.13-10,1.95-11.63,1.59-1.22,8.13,2.15,10.28,2.64A50,50,0,0,0,698.47,755.26Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#2f2e41"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M756.81,766.38c1.73,5.73,2,11.79,3.12,17.68s3.1,11.9,7.47,16a9.87,9.87,0,0,1,2.17,2.4,5.06,5.06,0,0,1-.75,5.23,13.13,13.13,0,0,1-4.39,3.37c-11.29,6.16-24,9.27-36.81,10.81a15.51,15.51,0,0,1-6.82-.25c-2.18-.74-4.11-2.7-4.07-5a2.55,2.55,0,0,1,.6-1.73,3.73,3.73,0,0,1,1.35-.79c4.72-1.94,9.51-4.05,13.16-7.63s5.94-9,4.53-13.86A27.42,27.42,0,0,0,733,786.2a108.35,108.35,0,0,1-5-9.69l-4.4-9.23c-1.29-2.7-2.59-5.48-2.81-8.46a40.6,40.6,0,0,0,16.22-2.6,25.51,25.51,0,0,0,6.67-4c1.7-1.42,3.25-4.07,5.54-2.22,1.84,1.48,3,5.65,4.08,7.76A57,57,0,0,1,756.81,766.38Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#2f2e41"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M692.33,537.19c.44,3.84,4.16,6.37,7.71,7.89l-22.47,7.17c1.45-2.78.28-6.18-1.16-9a50.93,50.93,0,0,0-4-6.41c-.22-.31-.47-.7-.31-1.06a1.12,1.12,0,0,1,.63-.49c4.62-2.06,9.38-4.19,14.43-4.94,1.46-.21,4.22-.79,5.31.69S692.12,535.42,692.33,537.19Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#fbbebe"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M692.33,537.19c.44,3.84,4.16,6.37,7.71,7.89l-22.47,7.17c1.45-2.78.28-6.18-1.16-9a50.93,50.93,0,0,0-4-6.41c-.22-.31-.47-.7-.31-1.06a1.12,1.12,0,0,1,.63-.49c4.62-2.06,9.38-4.19,14.43-4.94,1.46-.21,4.22-.79,5.31.69S692.12,535.42,692.33,537.19Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _c("circle", {
          attrs: { cx: "590.62", cy: "465.59", r: "17.62", fill: "#fbbebe" }
        }),
        _c("path", {
          attrs: {
            d:
              "M664,667.68c1.71,2.05,4.72,2.45,7.35,2,6.15-1,11.18-5.53,17.2-7.16,7.38-2,15.19.57,22.16,3.72s13.9,7,21.52,7.54c-6.89-15.36-2.95-33.84-9.54-49.33-1.61-3.79-3.86-7.44-4.22-11.54-.45-5.09,2.09-10,2.48-15.06.36-4.51-1-9-2.3-13.3q-2.41-7.92-4.82-15.84c-1.8-5.91-3.65-11.92-7.14-17-1.29-1.87-1.68-5.66-3.64-6.79-4.28-2.47-10.77.64-15.41.81s-8.87,3.47-11.58,7.2c-2.87,3.94-4.5,8.63-6,13.27a126.15,126.15,0,0,0-5.33,21.23c-.15,1.08-.28,2.16-.38,3.25-1,10.27.46,20.6.54,30.92v.07c.1,13.09-2,26.1-2.39,39.18C662.46,663.24,662.52,665.85,664,667.68Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#2f2e41"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M664.92,621.61c3.45-.87,6.57-3.1,9.25-5.54a38.67,38.67,0,0,0,6.14-7A49.86,49.86,0,0,0,685.6,598a129.36,129.36,0,0,0,7-32.27c.26-3,.34-6.22-1.45-8.6a7.24,7.24,0,0,0-8.75-2.12c-2.36,1.15-3.89,3.48-5.31,5.71-2.81,4.42-5.64,8.9-7.45,13.82-.8,2.18-1.39,4.42-2.17,6.61a61,61,0,0,1-2.74,6.33c-.15,1.08-.28,2.16-.38,3.25C663.42,601,664.84,611.29,664.92,621.61Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M691.1,555.2c1.79,2.38,1.71,5.63,1.46,8.59a129.18,129.18,0,0,1-7,32.27,49.43,49.43,0,0,1-5.29,11.16,39.07,39.07,0,0,1-6.14,7c-3.4,3.1-7.54,5.87-12.15,5.91a23.16,23.16,0,0,1-7.56-1.65L616.87,605.7c-.38-2.14,1.13-4.64,1.84-6.7l2-5.93c.57-1.64,1.23-3.41,2.72-4.3s3.85.33,5.09,1.32,2.18,2.29,3.4,3.3c2.31,1.92,5.36,2.64,8.3,3.3l8.43,1.89a35.2,35.2,0,0,0,9.38,1.25c2.35-7.18,6.82-13.5,9.35-20.62.78-2.18,1.37-4.43,2.18-6.61,1.8-4.92,4.64-9.39,7.45-13.82,1.41-2.22,2.94-4.55,5.31-5.71A7.23,7.23,0,0,1,691.1,555.2Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#2f2e41"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M684.89,526.66a8.89,8.89,0,0,0-1.06-3.3,2.77,2.77,0,0,0-3-1.32c-1.76.55-2.35,3.27-4.19,3.36-1.24.06-2.13-1.2-2.52-2.38s-.6-2.53-1.53-3.36a5.7,5.7,0,0,0-2.18-1c-4.27-1.35-8.68-3.84-10.1-8.09a4.84,4.84,0,0,1-.23-2.71c.65-2.69,4-3.5,6.55-4.47s5-2.63,7.5-3.89,5.4-2.15,8.15-1.51a42.47,42.47,0,0,1,4.11,1.53c4.14,1.44,9.21.77,12.42,3.76a12.83,12.83,0,0,1,3,5.24c2.24,6.22,3.66,13.6-.05,19.06-2.29,3.37-4.51,7.22-8.91,7.63C687.73,535.64,685.7,531,684.89,526.66Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#2f2e41"
          }
        }),
        _c("g", { attrs: { opacity: "0.1" } }, [
          _c("path", {
            attrs: {
              d:
                "M677.07,520.9c-.39-1.18-.6-2.53-1.52-3.36a5.7,5.7,0,0,0-2.18-1c-4.28-1.35-8.68-3.84-10.11-8.09a4.93,4.93,0,0,1-.22-2.71,3.39,3.39,0,0,1,.53-1.19c-1.63.71-3.05,1.65-3.45,3.31a4.84,4.84,0,0,0,.23,2.71c1.42,4.25,5.83,6.74,10.1,8.09a5.7,5.7,0,0,1,2.18,1c.93.83,1.13,2.17,1.53,3.36s1.28,2.44,2.52,2.38,1.84-1.19,2.63-2.14C678.22,523.12,677.43,522,677.07,520.9Z",
              transform: "translate(-88.65 -57.09)"
            }
          }),
          _c("path", {
            attrs: {
              d:
                "M695.79,533.06c-5.14.47-7.17-4.21-8-8.52a8.7,8.7,0,0,0-1-3.3,2.78,2.78,0,0,0-3-1.32,5.32,5.32,0,0,0-2.21,2,3,3,0,0,1,2.26,1.4,8.89,8.89,0,0,1,1.06,3.3c.81,4.31,2.84,9,8,8.52a8.25,8.25,0,0,0,5.28-2.74A7.46,7.46,0,0,1,695.79,533.06Z",
              transform: "translate(-88.65 -57.09)"
            }
          })
        ]),
        _c("ellipse", {
          attrs: {
            cx: "813.11",
            cy: "655.78",
            rx: "32.29",
            ry: "6.21",
            fill: "#4299e1"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "812.57",
            cy: "653.14",
            rx: "3.76",
            ry: "4.92",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "812.57",
            cy: "647.12",
            rx: "3.76",
            ry: "4.92",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "812.57",
            cy: "641.11",
            rx: "3.76",
            ry: "4.92",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "812.57",
            cy: "635.09",
            rx: "3.76",
            ry: "4.92",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "812.57",
            cy: "629.07",
            rx: "3.76",
            ry: "4.92",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "812.57",
            cy: "623.06",
            rx: "3.76",
            ry: "4.92",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "812.57",
            cy: "617.04",
            rx: "3.76",
            ry: "4.92",
            fill: "#3f3d56"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M915.29,633a18.19,18.19,0,0,0,1.4-2.06l-9.88-1.62,10.69.07a18.11,18.11,0,0,0,.34-14.27l-14.34,7.44,13.22-9.72A18,18,0,1,0,887,633a17.92,17.92,0,0,0-2.06,3.28l12.83,6.67-13.68-4.59A18,18,0,0,0,887,655.24a18,18,0,1,0,28.31,0,18,18,0,0,0,0-22.27Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M883.12,644.1A17.91,17.91,0,0,0,887,655.24a18,18,0,1,0,28.31,0C917.7,652.17,883.12,642.08,883.12,644.1Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "148.42",
            cy: "776.87",
            rx: "46.49",
            ry: "8.94",
            fill: "#4299e1"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "147.64",
            cy: "773.07",
            rx: "5.41",
            ry: "7.09",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "147.64",
            cy: "764.41",
            rx: "5.41",
            ry: "7.09",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "147.64",
            cy: "755.75",
            rx: "5.41",
            ry: "7.09",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "147.64",
            cy: "747.09",
            rx: "5.41",
            ry: "7.09",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "147.64",
            cy: "738.43",
            rx: "5.41",
            ry: "7.09",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "147.64",
            cy: "729.76",
            rx: "5.41",
            ry: "7.09",
            fill: "#3f3d56"
          }
        }),
        _c("ellipse", {
          attrs: {
            cx: "147.64",
            cy: "721.1",
            rx: "5.41",
            ry: "7.09",
            fill: "#3f3d56"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M256.55,718.93a27.23,27.23,0,0,0,2-3l-14.22-2.34,15.38.12a26,26,0,0,0,.49-20.55L239.58,703.9l19-14a25.93,25.93,0,1,0-42.83,29,25.83,25.83,0,0,0-3,4.72l18.47,9.6-19.69-6.61A25.93,25.93,0,0,0,215.79,751a25.93,25.93,0,1,0,40.76,0,25.92,25.92,0,0,0,0-32.06Z",
            transform: "translate(-88.65 -57.09)",
            fill: "#4299e1"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M210.24,735a25.85,25.85,0,0,0,5.55,16,25.93,25.93,0,1,0,40.76,0C260,746.58,210.24,732.05,210.24,735Z",
            transform: "translate(-88.65 -57.09)",
            opacity: "0.1"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }